export default function (componentName: string) {
  return (className: string) => `${componentName}-${className}`;
}
